export enum CampaignStatusEnum {
  IN_PROGRESS = 1,
  FINISHED = 2
}
